// hooks/useInfiniteScroll.ts
import { DemoItem } from "common/utils/helper";
import { useEffect, useRef } from "react";

export const useInfiniteScroll = (
  containerRef: React.RefObject<HTMLElement>,
  sentinelRef: React.RefObject<HTMLElement>,
  loadMore: () => void,
  items: DemoItem[]
) => {
  const observerRef = useRef<IntersectionObserver | null>(null);
  console.log('items', items);
  useEffect(() => {
    if (!sentinelRef.current || !containerRef.current) return;
    observerRef.current?.disconnect();

    const options: IntersectionObserverInit = {
      root: containerRef.current,
      rootMargin: "0px 0px 200% 0px",
      threshold: 0,
    };

    observerRef.current = new IntersectionObserver((entries) => {
      if (entries.some((e) => e.isIntersecting) && items.length > 0) loadMore();
    }, options);

    observerRef.current.observe(sentinelRef.current);

    return () => observerRef.current?.disconnect();
  }, [containerRef, sentinelRef, loadMore]);
};
